// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/modules/components/elements/about.less
// module id = 399
// module chunks = 0